import {
  getHostingSitesV2QueryKey,
  getSitesDomainsV2QueryKey,
  getSitesInfoQueryKey,
} from '@newfold/huapi-js';

export const getStagingPromotionQueryKeys = (
  parentSiteId: string | number,
  stagingSiteId: string | number,
  hostingId: string | number,
): any[] => {
  return [
    /*
      These query keys can't be labeled as "current staging" or "former parent" or the
      like, because that will differ depending on which stage of promotion they are
      called during. However, generating each query key for both parent and staging
      ensures that we invalidate whichever one we need at any point during promotion.
    */

    // Staging tab site list
    // @ts-expect-error
    getHostingSitesV2QueryKey(hostingId, {
      parent_site_id: Number(parentSiteId),
    }),
    // @ts-expect-error
    getHostingSitesV2QueryKey(hostingId, {
      parent_site_id: Number(stagingSiteId),
    }),

    // Site info/context
    getSitesInfoQueryKey(Number(stagingSiteId)),
    getSitesInfoQueryKey(Number(parentSiteId)),

    // Domain tab
    getSitesDomainsV2QueryKey(String(stagingSiteId)),
    getSitesDomainsV2QueryKey(String(parentSiteId)),
  ];
};
